import React, { useState } from "react";
import { ImagePlus } from "lucide-react";

const KEY = (shopId) => `vb_logo_nudge_snooze_${shopId}`;
const WEEK = 7 * 24 * 60 * 60 * 1000;
const snoozed = (shopId) => { try { return Date.now() < Number(localStorage.getItem(KEY(shopId)) || 0); } catch { return false; } };

export const logoNudgeVisible = (shop) => !!shop && !shop.logo?.trim() && !snoozed(shop.shop_id);

// Shown only while the selected shop has no saved logo; "Baad mein" snoozes 7 days per shop (this browser only).
export function LogoNudge({ shop, onUpload, onLater }) {
  const [, force] = useState(0);
  if (!logoNudgeVisible(shop)) return null;
  const later = () => { try { localStorage.setItem(KEY(shop.shop_id), String(Date.now() + WEEK)); } catch { /* storage blocked: snooze lasts this session only */ } force((x) => x + 1); onLater?.(); };
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-3 rounded-xl border border-emerald-200 bg-white px-3 py-3" data-testid="logo-nudge">
      <span className="hidden sm:flex w-10 h-10 rounded-xl bg-white border border-emerald-200 text-emerald-700 items-center justify-center flex-shrink-0"><ImagePlus className="w-5 h-5" /></span>
      <div className="flex-1 min-w-0 text-sm">
        <div className="font-semibold text-slate-900">Apni dukaan ka logo lagaayein</div>
        <div className="text-xs text-slate-600 mt-0.5">Logo QR poster, shop card aur share preview mein dikhega.</div>
      </div>
      <div className="flex gap-2 flex-shrink-0">
        <button onClick={onUpload} className="inline-flex items-center gap-1.5 rounded-full bg-emerald-700 hover:bg-emerald-800 text-white px-4 py-2 min-h-[40px] text-sm font-semibold" data-testid="logo-nudge-upload">
          <ImagePlus className="w-4 h-4" /> Logo upload karein
        </button>
        <button onClick={later} className="rounded-full border border-slate-200 bg-white hover:bg-slate-50 text-slate-600 px-4 py-2 min-h-[40px] text-sm font-semibold" data-testid="logo-nudge-later">Baad mein</button>
      </div>
    </div>
  );
}
